module.exports = __webpack_public_path__ + "img/6-Silver D Glatt.jpg";